import React from "react";
import InputCustom from "../../../components/InputCustom";
import Button from "../../../components/Button";
import BetterCircularProgress from "../../../components/BetterCircularProgress";
import { formatCNPJInput } from "../../../utils/Utils";
import styles from "../../../styles/Configuracoes.module.scss";

const touched = { razao_social: true, cnpj: true, email: true };

export default function TabEmpresa({ form_empresa, erros_empresa, loading, loading_empresa, onChange, onSalvar }) {
  return (
    <BetterCircularProgress loading={loading_empresa}>
      <>
        <div className={styles.card}>
          <InputCustom
            label="Razão social"
            name="razao_social"
            type="text"
            value={form_empresa.razao_social}
            onChange={(e) => onChange("razao_social", e.target.value)}
            disabled={loading}
            required
            errors={erros_empresa}
            touched={touched}
          />

          <div className={styles.gridDuasColunas}>
            <InputCustom
              label="CNPJ"
              name="cnpj"
              type="text"
              value={form_empresa.cnpj}
              onChange={(e) => onChange("cnpj", formatCNPJInput(e).target.value)}
              maxLength={18}
              disabled={loading}
              required
              errors={erros_empresa}
              touched={touched}
            />

            <InputCustom
              label="E-mail"
              name="email"
              type="email"
              value={form_empresa.email}
              onChange={(e) => onChange("email", e.target.value)}
              disabled={loading}
              required
              errors={erros_empresa}
              touched={touched}
            />
          </div>
        </div>

        <div className={styles.botoesRodape}>
          <Button
            type="button"
            variant="primary"
            size="md"
            loading={loading}
            disabled={loading}
            onClick={onSalvar}
          >
            Salvar dados
          </Button>
        </div>
      </>
    </BetterCircularProgress>
  );
}
